import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0418 2c2.6638.00109 5.1641 1.03313 7.0442 2.90642C20.9662 6.77966 22.001 9.26966 22 11.9177c-.0022 5.4644-4.47 9.9104-9.9581 9.9104h-.0042c-1.6666-.0006-3.30419-.4167-4.75869-1.2063L2 22l1.41278-5.1355c-.87146-1.5031-1.32998-3.2079-1.32927-4.9547C2.08571 6.44555 6.55294 2 12.0418 2zm5.0547 12.4422c-.0055-.0701-.0172-.1205-.0327-.1463-.05-.0832-.167-.1397-.3403-.2232-.0421-.0202-.0874-.0421-.1359-.0663-.2485-.124-1.4703-.7235-1.6981-.8062s-.3934-.124-.5591.124c-.1656.2481-.6418.8063-.7868.9717-.1449.1652-.2899.186-.5384.062-.0406-.0203-.096-.0443-.1644-.0739-.3499-.1513-1.04-.4499-1.8339-1.1561-.7388-.657-1.23751-1.4685-1.38248-1.7166-.02383-.0408-.04025-.0785-.05049-.1136-.01311-.0449-.01608-.0855-.01154-.1228.01348-.1107.09323-.1921.171-.2693.07447-.074.16002-.1779.24558-.2817.04283-.0521.08573-.1041.12723-.1524.1056-.123.1513-.2162.2136-.3429.0109-.0223.0224-.0457.0348-.0705.0117-.0232.0209-.0461.0279-.06847.0242-.07733.0226-.14979.0071-.2174-.012-.05233-.0324-.10176-.0557-.14827-.0416-.08301-.278-.65699-.49187-1.17627-.10565-.25648-.2058-.49962-.27426-.66366-.17806-.42649-.35858-.4255-.5034-.4247-.01923.0001-.03784.0002-.05572-.0007-.14478-.00713-.31063-.00865-.47629-.00865-.16567 0-.43486.06196-.66261.30999-.01461.01591-.03093.03328-.04867.05216-.22163.23583-.66568.70834-.78879 1.55583-.01168.08045-.02048.16428-.02591.2516C7.0022 9.5867 7 9.65591 7 9.72724c0-.00001 0 .00001 0 0 0 .22743.03096.45346.08213.67166.22176.9457.82316 1.7461.9304 1.8889l.00214.0028c.00814.0109.02274.0317.04362.0616.29771.4257 1.87204 2.677 4.20141 3.6801.5929.2553 1.0558.4078 1.4166.5219.5954.1887 1.1371.162 1.5653.0982.4774-.0711 1.4702-.5994 1.6773-1.1782.0178-.0498.034-.0989.0489-.1472.1145-.3735.1433-.6987.1287-.8848z",
    fill: "currentColor"
  }));
});